<div *ngIf="selecionado">
  <app-previsao-compra-cadastro
    [model]="selecionado"
    (buscar)="buscar($event)"
    [state]="state">
  </app-previsao-compra-cadastro>
</div>
<div *ngIf="!selecionado">
  <app-previsao-compra-filtro [filtros]="filtros"></app-previsao-compra-filtro>
  <app-previsao-compra-lista
    [filtros]="filtros"
    (exibir)="selecionar($event)"
    (definirFiltro)="definirFiltro()">
  </app-previsao-compra-lista>
</div>